<template>
<div class="chapter">
<div class="inner_page">
<h2 class="head"><a id="page_vii"></a><strong>CONTENTS</strong></h2>
<p class="toc"><a href="#/xhtml/intro"><strong>Introduction: On Your Marks!</strong></a></p>
<p class="toc"><span href="#/xhtml/chapter01" title="Link target outside of Sample"><strong>Chapter 1 The Period</strong></span></p>
<p class="toc"><span href="#/xhtml/chapter02" title="Link target outside of Sample"><strong>Chapter 2 The Question Mark</strong></span></p>
<p class="toc"><span href="#/xhtml/chapter03" title="Link target outside of Sample"><strong>Chapter 3 The Exclamation Point</strong></span></p>
<p class="toc"><span href="#/xhtml/chapter04" title="Link target outside of Sample"><strong>Chapter 4 The Comma</strong></span></p>
<p class="toc"><span href="#/xhtml/chapter05" title="Link target outside of Sample"><strong>Chapter 5 The Semicolon</strong></span></p>
<p class="toc"><span href="#/xhtml/chapter06" title="Link target outside of Sample"><strong>Chapter 6 The Colon</strong></span></p>
<p class="toc"><span href="#/xhtml/chapter07" title="Link target outside of Sample"><strong>Chapter 7 The Dash</strong></span></p>
<p class="toc"><span href="#/xhtml/chapter08" title="Link target outside of Sample"><strong>Chapter 8 The Apostrophe</strong></span></p>
<p class="toc"><span href="#/xhtml/chapter09" title="Link target outside of Sample"><strong>Chapter 9 Quotation Marks</strong></span></p>
<p class="toc"><span href="#/xhtml/chapter10" title="Link target outside of Sample"><strong>Chapter 10 Parentheses</strong></span></p>
<p class="toc"><span href="#/xhtml/chapter11" title="Link target outside of Sample"><strong>Chapter 11 Brackets</strong></span></p>
<p class="toc"><span href="#/xhtml/chapter12" title="Link target outside of Sample"><strong>Chapter 12 The Hyphen</strong></span></p>
<p class="toc"><span href="#/xhtml/chapter13" title="Link target outside of Sample"><strong>Chapter 13 The Ellipsis</strong></span></p>
<p class="toc"><span href="#/xhtml/afterword" title="Link target outside of Sample"><strong>Afterword</strong></span></p>
<p class="toc"><span href="#/xhtml/cheatsheet" title="Link target outside of Sample"><strong>Cheat Sheet</strong></span><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?3a428f71